import React from "react";
import { css, useTheme } from "@emotion/react";
import WrapperFromCore from "core/Components/Wrapper";

type Props = {
    children: React.ReactNode,
    isImageFirst: boolean,
    isImageBlock?: boolean,
};

const Wrapper: React.FC<Props> = ({
    children,
    isImageFirst,
    isImageBlock = false,
}) => {
    const theme = useTheme();

    const style = css`
        position: relative;
        overflow: hidden;
        width: 100%;

        ${isImageFirst && css`
            flex-direction: row-reverse;
        `}

        ${theme.breakpoints.down("md")} {
            flex-direction: column-reverse;
        }

        ${theme.breakpoints.up("lg")} {
            height: 500px;

            ${isImageBlock && css`
                align-items: center;
                column-gap: 24px;
            `}
        }

        ${isImageBlock && css`
            ${theme.breakpoints.up("lg")} {
                max-width: ${theme.breakpoints.sizes.lg}px;
            }

            ${theme.breakpoints.up("xl")} {
                max-width: ${theme.breakpoints.sizes.xl}px;
            }

            ${theme.breakpoints.up("xxl")} {
                max-width: ${theme.breakpoints.sizes.xxl}px;
            }

            ${theme.breakpoints.up("3xl")} {
                max-width: ${theme.breakpoints.sizes["3xl"]}px;
            }
        `}
    `;

    return (
        <WrapperFromCore css={style} useMaxWidth={false} useMinHeight={false}>{children}</WrapperFromCore>
    );
}

export default Wrapper;
